import { Back, Power0, TweenMax } from 'gsap';
import { scaleToFit } from '../../../Utils/Utils';
import { EmbeddedSprite } from '../EmbeddedSprite';
import { HighlightEffect } from '../HighlightEffect';
import { UIButton } from './UIButton';
import { Animation } from '../../Animations/Animation';
import Point = PIXI.Point;
import DEG_TO_RAD = PIXI.DEG_TO_RAD;

export default class CornerButton extends UIButton {
    public buttonWidth: number;
    public buttonHeight: number;
    private readonly highlight: HighlightEffect;
    private readonly icon: PIXI.Sprite;

    constructor(icon: string, scale: number = 0.8) {
        super('');
        this.highlight = new HighlightEffect({ scale });
        const { width, height } = this.highlight;
        this.icon = new EmbeddedSprite({ url: icon, width, height });
        this.icon.on(EmbeddedSprite.events.OnComplete, () => {
            this.icon.scale.set(
                scaleToFit(this.icon.width, this.icon.height, width * 0.4, height * 0.4)
            );
            this.emit(EmbeddedSprite.events.OnComplete);
        });
        this.icon.alpha = 0;
        this.buttonWidth = this.highlight.width;
        this.buttonHeight = this.highlight.height;
        this.addChild(this.highlight, this.icon);
    }

    public appear() {
        const scale = new Point(this.icon.scale.x, this.icon.scale.y);
        this.icon.scale.set(0);
        this.highlight.appear();
        const fadeInAnimation = new Animation({});
        fadeInAnimation.add(TweenMax.to(this.icon, 0.2, { alpha: 1 }));
        fadeInAnimation.addToLast(
            TweenMax.to(this.icon.scale, 0.5, {
                x: scale.x,
                y: scale.y,
                ease: Back.easeOut,
            })
        );
        fadeInAnimation.add(() => wiggleAnimation.play());
        const wiggleAnimation = new Animation({ repeat: -1 });
        wiggleAnimation.add(
            TweenMax.to(this.icon, 0.15, {
                rotation: 10 * DEG_TO_RAD,
            })
        );
        wiggleAnimation.add(
            TweenMax.to(this.icon, 0.15, {
                rotation: -10 * DEG_TO_RAD,
            })
        );
        wiggleAnimation.add(
            TweenMax.to(this.icon, 0.15, {
                rotation: 0,
            })
        );
        wiggleAnimation.add(
            TweenMax.to(this.icon.scale, 0.4, {
                x: scale.x * 0.9,
                y: scale.y * 0.9,
                ease: Power0.easeNone,
            })
        );
        wiggleAnimation.add(
            TweenMax.to(this.icon.scale, 0.4, {
                x: scale.x,
                y: scale.y,
                ease: Power0.easeNone,
            })
        );
        fadeInAnimation.play();
    }

    public cleanUp() {
        TweenMax.killTweensOf(this);
        TweenMax.killTweensOf(this.icon);
        TweenMax.killTweensOf(this.icon.scale);
    }
}
